// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_od-0";
export var animationContainer = "_od-1";
export var itemPrice = "_od-a";
export var itemizedContent = "_od-9";
export var itemizedHeader = "_od-7";
export var itemizedRow = "_od-8";
export var itemizedSection = "_od-6";
export var modalContent = "_od-2";
export var orderName = "_od-3";
export var refundOption = "_od-4";
export var refundOptionsContainer = "_od-5";
export var shippingLabel = "_od-b";
export var totalRow = "_od-c";